import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, Settings } from 'lucide-react';
import CookieSettings from './CookieSettings';

export const Footer: React.FC = () => {
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  return (
    <>
      <footer className="fixed bottom-0 w-full bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm border-t border-slate-200 dark:border-slate-800 py-3 z-40">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-lg text-slate-400 dark:text-slate-600">
            © 2026 Flash-Read. All rights reserved. All stories are original works protected by copyright.
          </p>
          <p className="text-sm text-slate-300 dark:text-slate-500 mt-1 leading-tight">
            <Link to="/terms" className="hover:text-slate-500 dark:hover:text-slate-400 underline bg-transparent border-none p-0 cursor-pointer text-inherit">Terms of Service</Link> · <Link to="/privacy" className="hover:text-slate-500 dark:hover:text-slate-400 underline bg-transparent border-none p-0 cursor-pointer text-inherit">Privacy Policy</Link> · <button onClick={() => setShowCookieSettings(true)} className="hover:text-slate-500 dark:hover:text-slate-400 underline bg-transparent border-none p-0 cursor-pointer text-inherit flex items-center gap-1 inline-flex"><Cookie className="w-3 h-3" /> Cookie Settings</button> · <a href="mailto:support@flash-read.com" className="hover:text-slate-500 dark:hover:text-slate-400 underline bg-transparent border-none p-0 cursor-pointer text-inherit">Contact Us</a> <span className="mx-2">·</span> <span className="ml-1">CIPA Compliant: No tracking without consent</span>
          </p>
        </div>
      </footer>

      {/* Cookie Settings Modal */}
      {showCookieSettings && (
        <CookieSettings
          showAsModal={true}
          onClose={() => setShowCookieSettings(false)}
        />
      )}
    </>
  );
};

export default Footer;
